<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-new" scrollable centered button-size="sm">
      <template #modal-title v-if="this.data.id">
        <i class="fas fa-columns"></i> CRM - Editar Quadro
      </template>
      <template #modal-title v-else>
        <i class="fas fa-columns"></i> CRM - Novo Quadro
      </template>
      <div class="form-group row pt-2 pb-3">
        <div class="col-md-12">
          <label><small class="text-danger">*</small> Nome do quadro:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o nome do quadro'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pb-3">
        <div class="col-md-12">
          <label for="txtDescription"> Descrição:</label>
          <b-form-textarea
            v-model="form.descricao.value"
            :placeholder="'Digite uma breve descrição sobre o quadro'"
            :rows="form.descricao.rows"
            :size="form.descricao.maxlength"
            :noResize="form.descricao.noResize"></b-form-textarea>
          <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
      <div class="form-group row pb-3">
        <div class="col-md-6">
          <label><small class="text-danger">*</small> Data de Inicio:</label>
          <div class="input-group">
            <b-form-input type="date"
                          v-model="form.dataInicial.value"
                          :required="form.dataInicial.required"
                          :state="form.dataInicial.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label><small class="text-danger">*</small> Data de Término:</label>
          <div class="input-group">
            <b-form-input type="date"
                          v-model="form.dataFinal.value"
                          :required="form.dataFinal.required"
                          :state="form.dataFinal.state"></b-form-input>
          </div>
        </div>
        <h5 class="text-third mt-3 ml-3 pt-3">Pesquisa de Satisfação</h5>
        <div class="col-md-12 mt-2">
          <label for="txtGroup">Template de Ganho:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-user-check"></i></span>
            <b-form-select v-model="form.templateGanhoId.value" :options="form.templateGanhoId.options">
              <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <label for="txtGroup">Template de Perda:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-heart-broken"></i></span>
            <b-form-select v-model="form.templatePerdaId.value" :options="form.templatePerdaId.options">
              <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <label for="txtGroup">Template de Finalizado:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-heart-broken"></i></span>
            <b-form-select v-model="form.templateFinalizadoId.value" :options="form.templateFinalizadoId.options">
              <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-3">
        <div class="col-md-12">
          <div class="input-group">
            <label><small class="text-danger">*</small> Tipo de Quadro:</label>
            <div class="input-group">
              <b-form-select
                v-model="form.tipoBoard.value"
                :options="form.tipoBoard.options"
                :required="form.tipoBoard.required"
                :state="form.tipoBoard.state"
              ></b-form-select>
            </div>
          </div>

          <!-- <div class="input-group mt-2">
            <label>Usuários:</label>
            <v-select
              multiple
              v-model="form.usuariosPermissao.value"
              :options="form.usuariosPermissao.options"
              label="text"
              :reduce="x => x.value"
              class="w-100"
            >
              <template v-slot:no-options>Nenhum Usuário encontrado.</template>
            </v-select>
          </div> -->
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="onSave" v-b-tooltip.hover :title="'Salvar'"><i class="fas fa-check-circle"></i><span class="d-md-down-none"> Salvar</span></button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import CampanhaModeloRepository from '@/shared/http/repositories/configurations/templates.js'
import AccountRepository from '@/shared/http/repositories/access/account.js'

const CRMNewForm = {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  descricao: {
    value: '',
    maxlength: '70',
    required: false,
    rows: '3',
    noResize: true
  },
  dataInicial: {
    value: '',
    required: true,
    state: null
  },
  dataFinal: {
    value: '',
    required: true,
    state: null
  },
  templateGanhoId: {
    value: null,
    defaultValue: null,
    required: false,
    state: null,
    options: []
  },
  templatePerdaId: {
    value: null,
    defaultValue: null,
    required: false,
    state: null,
    options: []
  },
  templateFinalizadoId: {
    value: null,
    defaultValue: null,
    required: false,
    state: null,
    options: []
  },
  tipoBoard: {
    value: null,
    options: [
      {text: 'Venda', value: 'VENDA'},
      {text: 'Operação', value: 'OPERACAO'},
      {text: 'Cobrança', value: 'COBRANCA'}
    ],
    required: true
  }
  // ,
  // usuariosPermissao: {
  //   value: [],
  //   options: [],
  //   required: false,
  //   state: null
  // }
}

export default {
  name: 'CRMNew',
  mixins: [ActionsForm],
  data () {
    return {
      data: {
        id: null,
        nome: null,
        favorito: null,
        tipo: null,
        descricao: null,
        dataInicial: null,
        dataFinal: null,
        templateGanhoId: null,
        templatePerdaId: null,
        templateFinalizadoId: null,
        tipoBoard: null
        // usuariosPermissaoIds: null
      },
      form: CRMNewForm
    }
  },
  methods: {
    showModal () {
      this.onClear()
      this.onGetAllTemplates()
      this.form.dataInicial.value = String(new Date().toLocaleDateString('en-CA'))
      this.$refs['modal-new'].show()
    },
    hideModal () {
      this.$refs['modal-new'].hide()
    },
    onLoad () {
      this.onClear()
      this.onEdit(this.data)
      this.onLoadAllAccount()
    },
    onEdit (obj) {
      if (obj) {
        Tools.SetValueInForm(this.form, this.data, obj)
        if (obj.dataInicial) {
          this.form.dataInicial.value = this.moment(obj.dataInicial.substring(0, 19)).format('YYYY-MM-DD')
        }

        if (obj.dataFinal) {
          this.form.dataFinal.value = this.moment(obj.dataFinal.substring(0, 19)).format('YYYY-MM-DD')
        }

        if (obj.templateGanhoId) {
          this.form.templateGanhoId.value = obj.templateGanhoId
        }

        if (obj.templatePerdaId) {
          this.form.templatePerdaId.value = obj.templatePerdaId
        }

        if (obj.templateFinalizadoId) {
          this.form.templateFinalizadoId.value = obj.templateFinalizadoId
        }

        // if (obj.usuariosPermissao) {
        //   this.form.usuariosPermissao.value = obj.usuariosPermissao.map(responsavel => responsavel.id) || []
        // }
      }
    },
    onCreate () {
      loading.push()
      this.data.favorito = false
      this.data.tipo = 0
      // if (this.form.usuariosPermissao.value && this.form.usuariosPermissao.value.length !== 0) {
      //   this.data.usuariosPermissaoIds = this.form.usuariosPermissao.value
      // }
      BoardRepository.Create(this.data)
        .then((response) => {
          loading.pop()
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
          }
          this.hideModal()
          this.$emit('Back')
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.favorito = false
      this.data.tipo = 0
      // if (this.form.usuariosPermissao.value.length !== 0) {
      //   this.data.usuariosPermissaoIds = this.form.usuariosPermissao.value
      // }
      BoardRepository.Update(this.data)
        .then((response) => {
          loading.pop()
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
          }
          this.hideModal()
          this.$emit('Back')
        })
        .catch(this.onException)
    },
    onGetAllTemplates () {
      loading.push()
      CampanhaModeloRepository.Search('tipo=1&finalidade=2&', 500, 0)
        .then((response) => {
          this.form.templateGanhoId.options = this.onResultDropdown(response)
          this.form.templatePerdaId.options = this.onResultDropdown(response)
          this.form.templateFinalizadoId.options = this.onResultDropdown(response)
        })
        .catch(this.onException)
    },
    onLoadAllAccount () {
      loading.push()
      AccountRepository.GetAllName()
        .then((response) => {
          loading.pop()
          // this.form.usuariosPermissao.options = response.data.map(usuario => ({ 'text': usuario.nomePessoa, 'value': usuario.id }))
        })
        .catch((e) => {
          loading.pop()
          console.log(e.message)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/modal/crmnewmodal.vue